import { render, staticRenderFns } from "./addUserToTags.vue?vue&type=template&id=1aa02f06&scoped=true"
import script from "./addUserToTags.vue?vue&type=script&lang=js"
export * from "./addUserToTags.vue?vue&type=script&lang=js"
import style0 from "./addUserToTags.vue?vue&type=style&index=0&id=1aa02f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa02f06",
  null
  
)

export default component.exports